// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_nXx","cls2":"ImpactHubModal-cls2__or ImpactHubModal-cls1_nXx"};